/* @flow */

import React from 'react';
import { Card, Input, Button } from 'semantic-ui-react';
import ResourceDimmer from 'shared/components/ResourceDimmer';
import type { GalleryImage } from '../types';

type Props = {
  image: GalleryImage,
  images: Array<GalleryImage>,
  onUpdate: (image: GalleryImage) => void,
  onOrderChanged: (image: GalleryImage, order: number) => void,
  onDelete: (image: GalleryImage) => void,
};

const styles = {
  input: {
    margin: '8px',
  },
};

const GalleryItem = ({
  image,
  images,
  onUpdate,
  onOrderChanged,
  onDelete,
}: Props) => {
  const update = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      onUpdate({
        ...image,
        title: event.target.value,
      });
    }
  };

  const orderChanged = order => onOrderChanged(image, order);

  const remove = () => onDelete(image);

  const canOrderUp = image.order > 0;
  const canOrderDown = image.order < images.length - 1;
  const orderUp = () => orderChanged(image.order - 1);
  const orderDown = () => orderChanged(image.order + 1);

  return (
    <Card key={image.order}>
      <ResourceDimmer resource={image.resource && image.resource.source}>
        <div>
          <Button
            type="button"
            compact
            icon="chevron left"
            onClick={orderUp}
            disabled={!canOrderUp}
          />
          <Button onClick={remove} compact icon="close" color="red" />
          <Button
            type="button"
            compact
            icon="chevron right"
            onClick={orderDown}
            disabled={!canOrderDown}
          />
        </div>
      </ResourceDimmer>
      <Card.Content extra>
        <Input
          value={image.title || ''}
          onChange={update}
          fluid
          placeholder="Titre"
          style={styles.input}
        />
      </Card.Content>
    </Card>
  );
};

export default GalleryItem;



// WEBPACK FOOTER //
// ./src/modules/my-space/components/GalleryItem.js